import { CLAIM_QUEUE_CONFIG } from './claim-queue.config';

/** Copy for the claim workspace. */
export const CLAIM_WORKSPACE_CONFIG = {
  title: (claimNumber: string) => `Claim #${claimNumber}`,
  description: 'Everything about this claim on one page.',
  breadcrumbs: { claims: 'Claims', workspace: 'Workspace' },
  classicView: 'Classic view',
  audit: {
    title: 'Audit trail',
    subtitle: 'Every decision, amount and record change on this claim.',
    entries: (count: number) => `${count} ${count === 1 ? 'entry' : 'entries'}`,
    show: 'Show',
    hide: 'Hide',
  },
  openWorkspace: 'Open workspace',
  previousFlowNote: {
    title: 'Previous claims flow',
    text: 'This claim was opened while the new claims flow was off, so it finishes the way it started: no authorization step, charges or evidence holds.',
  },

  context: {
    title: 'Claim context',
    contract: 'Contract',
    customer: 'Customer',
    asset: 'Asset',
    noAsset: 'No asset on this contract.',
    coverage: 'Coverage',
    deductible: 'Deductible',
    remainingLimit: 'Remaining limit',
    noJob: 'Select a job to see its coverage.',
    claimStatus: 'Claim status',
    authorization: 'Authorization',
    payment: 'Payment',
    paid: (paid: string, payable: string) => `${paid} paid of ${payable}`,
    authorizationLabels: CLAIM_QUEUE_CONFIG.authorization.labels,
    paymentLabels: CLAIM_QUEUE_CONFIG.paymentReadiness.labels,
    repairDeadline: 'Repair deadline',
    noRepairDeadline: 'None',
    contactReason: 'Contact needed',
    noContact: 'No one to contact',
    contactReasonLabels: CLAIM_QUEUE_CONFIG.contactReason.labels,
    saveContactReason: 'Save',
    contactSaved: 'Contact reason updated',
    contactCleared: 'Contact reason cleared',
    contactFailed: "We couldn't save the contact reason.",
  },

  approvals: {
    title: 'Approvals and split',
    subtitle: "Approvals the tenant's rules ask for before money moves, and how it's split between payees.",
  },

  money: {
    title: 'Money',
    requested: 'Requested',
    authorizedGross: 'Authorized gross',
    tax: 'Tax',
    deductible: 'Deductible',
    netPayable: 'Net payable',
    noCharges: 'No charges on this claim yet.',
    refreshing: 'Updating totals...',
    refreshFailed: "We couldn't update the totals.",
    retry: 'Try again',
    unsaved: 'Changes in the open dialog are not in these totals until you save.',
  },

  jobs: {
    title: 'Jobs',
    subtitle: 'Click a job to see its charges, holds and decision.',
    viewing: 'Viewing',
    empty: 'No jobs on this claim yet.',
    other: 'Other',
    requested: 'Requested',
    authorized: 'Authorized',
  },

  job: {
    selectPrompt: 'Select a job above to see its charges, holds and decision.',
    decision: 'Decision',
    noDecision: 'No decision yet.',
  },

  actions: {
    details: 'Edit job',
    cure: 'Cure',
    decide: 'Decide',
    resolve: 'Resolve',
  },

  // Why an action is off; the API checks again.
  reasons: {
    notEditable: 'This job is authorized, or the claim is no longer open.',
    removed: 'This job was removed.',
    noPermission: "You don't have permission for this.",
    decided: 'This job is already decided.',
    notReady: 'Add a charge or a cure first.',
    notDecided: 'Decide the job first.',
    rejected: 'Rejected jobs are not resolved.',
    noCure: 'Set a cure first.',
  },

  states: {
    loading: 'Loading the claim...',
    loadFailed: "We couldn't load this claim. Reload to try again.",
    forbidden: "You don't have access to this claim.",
  },
};
